import { Link } from "react-router-dom";

import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../components/ui";

const Actions = props => {
  const { values } = props || {};
  const { id } = values?.item || values || {};

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={`${id}/form`} title="Edit Instance">
              <IconButton variant="clean" title="Edit Instance">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
